import axios from 'axios'

const http = (token) => {
  return axios.create({
    baseURL: 'https://api.rosetta.ai/',
    timeout: 20000,
    headers: {
      // "Content-Type": "application/x-www-form-urlencoded",
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/vnd.rosetta-ai.v2+json'
    }
  });
} 

export default http